import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getDefaultClusterId = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.defaultClusterId ?? '';
};
export default getDefaultClusterId;
